import { useCallback } from 'react';
import { SubmitProviderInputsPayload } from '../../screens/SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { PageView, UserInteractionEvent } from '../../../models/analytics';
import { usePageViewEvents } from '../../../core/Analytics/usePageViewEvents';
import {
  VerificationTemplateView,
  VerificationTemplateViewProps,
} from './VerificationTemplateView';

export const VerificationTemplateScreen = ({ fields, onSubmit }: VerificationTemplateViewProps) => {
  const { sendViewInteractionEvent } = usePageViewEvents({
    pageView: PageView.VERIFICATION_TEMPLATE_SCREEN,
  });

  const handleSubmitWithAnalytics = useCallback(
    (values: SubmitProviderInputsPayload) => {
      sendViewInteractionEvent({
        interaction: UserInteractionEvent.SUBMIT_SUPPLEMENTAL_INFORMATION,
      });
      onSubmit(values);
    },
    [onSubmit, sendViewInteractionEvent]
  );

  return <VerificationTemplateView fields={fields} onSubmit={handleSubmitWithAnalytics} />;
};
